<img [src]="'assets/images/' + filename" style="width: 100%; height: 100%">